module.exports = __webpack_public_path__ + "static/media/email.dfbd3e23.svg";